import { load } from 'cheerio';
import UrlTypes from '@/enums/UrlTypes';
import { hasXmlDeclaration } from './hasXmlDeclaration';

/**
 * IO provider: classify by checking specific HTML markers.
*/
export function classifyIoSource(htmlSource: string): UrlTypes {

    if (hasXmlDeclaration(htmlSource)) {
        return UrlTypes.OTHER;
    }

    const $ = load(htmlSource);
    if ($('.elementor-sitemap-wrap').length > 0) {
        return UrlTypes.OTHER;
    }

    // Product indicators
    if (
        $('.io_product_container').length > 0 ||
        $('.io_product_picbox').length > 0 ||
        $('.io_product_infobox').length > 0
    ) {
        return UrlTypes.PRODUCT;
    }

    // Category indicators
    if (
        $('.io_category_wrapper').length > 0 ||
        $('.cat_div_wrapper').length > 0 ||
        $('.io_cat_description').length > 0 ||
        $('.category_id').length > 0
    ) {
        const categoryIdElem = $('.category_id').first();
        if (categoryIdElem.length > 0) {
            const text = categoryIdElem.text().trim();
            if (/^\d+$/.test(text)) {
                return UrlTypes.CATEGORY;
            }
            return UrlTypes.CATEGORY_HUB;
        }
        return UrlTypes.CATEGORY;
    }

    if ($('[data-elementor-type="wp-page"]').length > 0 ||
        $('[data-elementor-type="wp-post"]').length > 0 ||
        $('article[id^="post-"]').length > 0 ||
        $('.pageContent').length > 0
    ) {
        return UrlTypes.PAGE;
    }

    // Default fallback
    return UrlTypes.OTHER;
}
